import React, { Component } from 'react'
import { MOVIE, AD } from '../constants/itemTypes.jsx'
import PosterFormatItem from  '../PosterFormatItem/index.jsx'
import BackgroundFormatItemContainer from '../BackgroundFormatItem/index.jsx';
import getMomentDateObj from '../functions/getMomentDateObj.js';
import getMomentNow from '../functions/getMomentNow.js';
import isCurrentPerformance from '../functions/isCurrentPerformance.js';
import getContainsIgnoredAttributes from '../functions/getContainsIgnoredAttributes.jsx';

const StripeItem = ({
    isChanging,
    item, 
    moviesData, 
    adsData, 
    theme, 
    filterType, 
    filterValue,  
    translation, 
    scrollToPosition, 
    isMobile, 
    onClickSlideItem, 
    onOpenPerformancePage, 
    stripeAppearance //is needed for overwrite
}) => {
    if(!item) {
        return ''
    }
    const { id, type } = item
    let itemData = ''

    if(MOVIE === type && _.has(moviesData, id)) {
        itemData = moviesData[id]
    } else if(AD === type && _.has(adsData, id)) {
        itemData = adsData[id] 
    } else {
        return ''
    }

    let isStillRelevant = true

    if(filterValue && filterType && filterType === "technical") {
        if(type === MOVIE) {
            const {performances, technologyAttributes} = itemData
            const containsIgnoredAttributes = getContainsIgnoredAttributes(technologyAttributes)
            const { timezone } = translation
            const dateNow = getMomentNow(timezone)
            
            const relevantPerformances = _.filter(performances, performance => {
                const {timeUtc, attributes} = performance
                const attributesFiltered = _.filter(attributes, attribute => {
                    return filterValue.toLowerCase() === attribute.name.toLowerCase()
                })
                
                if(attributesFiltered && attributesFiltered.length !== 0) {
                    if(isCurrentPerformance(dateNow, getMomentDateObj(timeUtc, timezone))) {
                        return performance
                    }
                }
            })

            if(relevantPerformances.length === 0 && !containsIgnoredAttributes) {
                isStillRelevant = false
            }
        }
    }

    if(!isStillRelevant) {
        return ''
    }

    if(theme === 'Arthouse') {
        return (
            <div className="order-wrapper slide-item">
                <BackgroundFormatItemContainer
                    itemID={id}
                    itemData={itemData}
                    stripeAppearance={stripeAppearance} //is needed for overwrite
                    queryStringValues={{}}
                    showPerformances={true}
                    filterValue={filterValue}
                    filterType={filterType}
                    translation={translation}
                    scrollToPosition={scrollToPosition}
                    isMobile={isMobile}
                    onClickItem={!isChanging ? onClickSlideItem : () => {}}
                    onOpenPerformancePage={onOpenPerformancePage}
                />
            </div>
        )
    } else {
        return (
            <div className="slide-item">
                <PosterFormatItem
                    itemID={id}
                    itemData={itemData}
                    filterValue={filterValue}
                    filterType={filterType}
                    showPerformances={true}
                    translation={translation}
                    scrollToPosition={scrollToPosition}
                    isMobile={isMobile}
                    onClickItem={!isChanging ? onClickSlideItem : () => {}}
                    onOpenPerformancePage={onOpenPerformancePage}
                />
            </div>
        )
    }
}

export default StripeItem
